import * as React from 'react';
import {AuthSetPasswordPartial} from "../../auth-set-password";

type Props = {};

export const AuthRequestVerificationPageContainer: React.FC<Props> = props => {
    return <AuthSetPasswordPartial processTitle={'First time user'} />
};

